import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../../API/apiClient ";

export const GetInvoiceHistory = createAsyncThunk(  
    'InvoiceHistory/Invoice',
    async ({status,offsetValue}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`Sales/InVoice/GetinVoiceHistory?DOCSTATUS=${status}&offsetValue=${offsetValue}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );
  export const GetInvoiceItems = createAsyncThunk(  
    'InvoiceHistory/InvoiceItems',
    async ({DocEntry}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`Sales/InVoice/GetinVoiceItems?DOCENTRY=${DocEntry}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );

  export const GetsearchInvoiceDeliver = createAsyncThunk(  
    'InvoiceHistory/searchInvoiceDeliver',
    async ({searchValue,PageType,tab}, { rejectWithValue }) => {
      try {        
        const response = await apiClient.get(`Sales/InVoice/GetsearchdelInv?DocStatus=${tab}&DocType=${PageType}&SearchText=${searchValue}`);
        return response.data;  
      } catch (error) {
        return rejectWithValue(error.response?.data || 'Error fetching data');
      }
    }
  );